import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { VendorApplicationStatusEnum } from '@/lib/api-admin/types';

export type VendorSort =
  | 'createdAt,desc'
  | 'createdAt,asc'
  | 'submittedAt,desc'
  | 'submittedAt,asc'
  | 'slaDueAt,asc'
  | 'slaDueAt,desc';

export const VENDOR_SORTABLE_COLUMNS = new Set(['createdAt', 'submittedAt', 'slaDueAt']);

export interface VendorFiltersState {
  keyword: string;
  status: ReadonlyArray<VendorApplicationStatusEnum>;
  slaDueBefore: string | null;
  assignedReviewerId: string | null;
  page: number;
  size: number;
  sort: VendorSort;
  setKeyword: (v: string) => void;
  toggleStatus: (s: VendorApplicationStatusEnum) => void;
  setStatuses: (ss: ReadonlyArray<VendorApplicationStatusEnum>) => void;
  setSlaDueBefore: (v: string | null) => void;
  setAssignedReviewerId: (v: string | null) => void;
  setPage: (p: number) => void;
  setSize: (s: number) => void;
  setSort: (s: VendorSort) => void;
  reset: () => void;
}

const INITIAL = {
  keyword: '',
  status: [] as ReadonlyArray<VendorApplicationStatusEnum>,
  slaDueBefore: null as string | null,
  assignedReviewerId: null as string | null,
  page: 1,
  size: 20,
  sort: 'submittedAt,desc' as VendorSort,
};

export const useVendorFiltersStore = create<VendorFiltersState>()(
  devtools(
    (set) => ({
      ...INITIAL,
      setKeyword: (keyword) => set({ keyword, page: 1 }),
      toggleStatus: (s) =>
        set((state) => {
          const next = state.status.includes(s)
            ? state.status.filter((x) => x !== s)
            : [...state.status, s];
          return { status: next, page: 1 };
        }),
      setStatuses: (ss) => set({ status: ss, page: 1 }),
      setSlaDueBefore: (slaDueBefore) => set({ slaDueBefore, page: 1 }),
      setAssignedReviewerId: (assignedReviewerId) => set({ assignedReviewerId, page: 1 }),
      setPage: (page) => set({ page }),
      setSize: (size) => set({ size, page: 1 }),
      setSort: (sort) => set({ sort, page: 1 }),
      reset: () => set({ ...INITIAL }),
    }),
    { name: 'vendor-filters' },
  ),
);
